import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../../shared/models/component-messages/simp_at/step2';
import { AttributionFromFNSimple } from '../../models/AttributionFromFNSimple';

@Component({
	selector: 'app-step2',
	templateUrl: './step2.component.html'
})
export class Step2Component implements OnInit {
	@Input() fnSimpleAttribution: AttributionFromFNSimple;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() uid = '';
	@Input() linkForRouter: string;

	public current_uid_natureMarche = 'TypeFNSSimpleDescMarche2';

	public step2 = new Step2();

	constructor() {}

	public ngOnInit() {}

	public getUid() {
		return this.uid;
	}

	public getUidNatureMarche() {
		return this.uid + '_SepSep_' + this.current_uid_natureMarche;
	}
}
